module.exports = __webpack_public_path__ + "static/media/LoginBackgroundSmall.7a9e3e09.svg";